module.exports = __webpack_public_path__ + "static/modernizace-php-aplikaci-2-d512d9dc1b419c98485b0a68e2bff24b.jpg";